import SearchBar from '@/vuetify_custom/v-form'
import { mapGetters } from "vuex";
import { search_types, flow_status_list } from '../fields'

export default {
  components: { SearchBar },
  data() {
    return {
      staff_accounts: [],
      company_accounts: []
    }
  },
  computed: {
    ...mapGetters('async', ['companies', 'account_titles', 'teams']),
    search_type() {
      return {
        type: 'select_field',
        key: 'search_type',
        label: '单据状态',
        items: search_types,
        'item-text': 'name',
        'item-value': 'uid',
        'hide-details': true,
        change: this.query
      }
    },
    flow_status_type() {
      return {
        type: 'select_field',
        key: 'flow_finished',
        label: '流程状态',
        clearable: true,
        items: flow_status_list,
        'item-text': 'name',
        'item-value': 'value',
        'hide-details': true,
        change: this.query
      }
    },
    flow_status_node() {
      return {
        type: 'select_field',
        key: 'flow_node_id',
        label: '流程节点',
        clearable: true,
        items: this.flow_nodes,
        'item-text': 'name',
        'item-value': 'id',
        'hide-details': true,
        change: this.query
      }
    },
    company_field() {
      return {
        type: 'select_field',
        key: 'company_id',
        label:'公司',
        items: this.companies,
        'item-text': 'short_name',
        'item-value': 'id',
        clearable: true,
        'hide-details': true,
        change: this.query
      }
    },
    team_field() {
      return {
        type: 'team_select',
        key: 'team_id',
        label: "项目组",
        placeholder: null,
        clearable: true,
        'hide-details': true,
        change: this.query
      }
    },
    search_input() {
      return {
        type: 'text_field',
        key: 'search',
        label: '搜索',
        'append-icon': "mdi-magnify",
        'single-line': true,
        'hide-details': true,
        clearable: true,
        // loading: this.loading,
        'click:append': this.search,
        'click:clear': this.searchClear,
        'keydown.enter': this.search
      }
    },
    action_field() {
      return {
        key: 'action',
      }
    },
    search_fields() {
      return [
        this.search_type,
        this.company_field,
        this.team_field,
        this.search_input,
        this.action_field
      ]
    },
    search_other_fields() {
      return [
        this.search_type,
        this.company_field,
        this.team_field,
        this.flow_status_type,
        this.flow_status_node,
        this.search_input,
        this.action_field
      ]
    },
    split_bill_fields() {
      return [
        this.search_input,
      ]
    },
    contactUnit() {
      let items = []
      let text_key = ''
      let value_key = ''
      const contact_unit_type = this.value && this.value.contact_unit_type ? this.value.contact_unit_type : ''
      switch (contact_unit_type) {
      case 'Client': // clients
        items = this.clients
        text_key = 'name'
        value_key = 'id'
        break;
      case 'PayeeCompany': // company
        items = this.company_accounts
        text_key = 'name'
        value_key = 'id'
        break
      case 'Customer': // staff
        items = this.staff_accounts
        text_key = 'name'
        value_key = 'id'
        break
      default:
        break;
      }
      return {
        label: '往来单位：',
        key: 'contact_unit_id',
        type: 'select_field',
        items,
        text_key,
        value_key
      }
    },
    receipt_purposes_hash() {
      if (!this.receipt_purposes || !(this.receipt_purposes && this.receipt_purposes.length)) {
        return {}
      }
      return this.receipt_purposes.reduce((total, item) => {
        total[item.kingdee_uid] = item
        return total
      }, {})
    }
  },
  methods: {
    copy(data) {
      this.$refs.editModal.show({
        ...data,
        _is_copy: true
      })
    },
    edit(data) {
      this.$refs.editModal.show(data)
    },
    del(data) {
      this.$emit('del', data)
    },
    addNew() {
      this.$refs.editModal.show()
    },
    success() {
      this.search()
    },
  }
}
